import { useTranslation } from 'next-i18next';

/**
 * LockedPlanFloatingText - 플랜 잠금 시 Footer 위에 표시되는 안내 띠
 *
 * @description
 * 퀴즈가 잠겨있을 때 MobileCTAFooter 바로 위에 화면 폭 전체로 붙는 안내 메시지입니다.
 *
 * Figma Reference: node-id=35341-37209
 *
 * @example
 * ```tsx
 * <MobileCTAFooter floatingText={<LockedPlanFloatingText isOwner />}>
 *   <MobileOwnerLockedCTAButtons {...props} />
 * </MobileCTAFooter>
 * ```
 */
export const LockedPlanFloatingText = ({
  isOwner
}: {
  isOwner: boolean;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full items-center justify-center bg-opacity-black-6 px-md py-xs backdrop-blur-[2px]" data-component="locked-plan-floating-text" data-sentry-component="LockedPlanFloatingText" data-sentry-source-file="LockedPlanFloatingText.tsx">
      <p className="w-full whitespace-pre-line break-words text-center text-body-sm-medium text-inverse">
        {t(isOwner ? 'detail.planExpired.ownerMessage' : 'detail.planExpired.viewerMessage')}
      </p>
    </div>;
};